import React from 'react'
import RefinementList, { RefinementListProps } from './refinementList'
import { Slider } from '../ui/slider/Slider'
import { PayRangesSliderModal } from '../ui/form/priceRangeSlider'

interface RefinementProps {
  attributes: RefinementListProps[]
}

const Refinement = ({ attributes }: RefinementProps) => (
  <div className="relative flex justify-center w-full">
    <Slider>
      {attributes.map(
        ({ name, attribute, transformLabel, searchable, type }) => {
          switch (type) {
            case 'range':
              return (
                <PayRangesSliderModal
                  key={attribute}
                  attribute={attribute}
                  name={name}
                />
              )

            default:
              return (
                <RefinementList
                  key={attribute}
                  attribute={attribute}
                  name={name}
                  transformLabel={transformLabel}
                  searchable={searchable}
                  type={type}
                />
              )
          }
        },
      )}
    </Slider>
  </div>
)

export default Refinement
